import * as React from 'react';

import { ImageNone } from '@cian/components';
import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';

import { ISimilarOffer } from '../../api/similar';
import { Link } from '../../common/components/link';
import { CurrencySymbol } from '../../utils/formatters';
import { IconsMetro } from './icons/icons_metro';
import * as styles from './index.css';

export interface ISimilarOfferItemProps {
  offer: ISimilarOffer;
  position: number;

  onClick(offer: ISimilarOffer, position: number): void;
}

const MAX_ADDRESS_LENGTH = 40;

export class SimilarOfferItem extends React.PureComponent<ISimilarOfferItemProps, {}> {
  public render() {
    const { offer } = this.props;

    return (
      <li className={styles['item']}>
        <a
          href={offer.url || ''}
          className={styles['image_link']}
          target="_blank"
          onClick={this.handleClick}
        >
          {
            offer.photoUrl
              ? <img src={offer.photoUrl} alt={offer.title || ''} />
              : <ImageNone containerStyle={styles['none_image']} />
          }
        </a>
        <Link
          href={offer.url || ''}
          className={styles['title']}
          target="_blank"
          onClick={this.handleClick}
        >
          {offer.title}
        </Link>
        {this.renderAddress()}
        {this.renderUnderground()}
        {offer.totalPriceRur &&
          <div className={styles['price']}>
            {numberToPrettyString(offer.totalPriceRur)} {CurrencySymbol.Rur}
          </div>
        }
      </li>
    );
  }

  private renderAddress = () => {
    const { address } = this.props.offer;

    if (!address) {
      return null;
    }

    if (address.length > MAX_ADDRESS_LENGTH) {
      return (
        <div className={styles['address']}>
          {address.slice(0, MAX_ADDRESS_LENGTH + 3) + '...'}
        </div>
      );
    }

    return (
      <div className={styles['address']}>{address}</div>
    );
  }

  private renderUnderground() {
    const { underground } = this.props.offer;

    if (!underground || !underground.text ||
      !underground.type || !underground.lineColor) {
      return null;
    }

    return (
      <div className={styles['metro']}>
        <IconsMetro
          color={underground.lineColor}
          type={underground.type}
        />
        <span>{underground.text}</span>
      </div>
    );
  }

  private handleClick = () => {
    this.props.onClick(this.props.offer, this.props.position);
  }
}
